// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

html {
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  font-family: var(--font-sans);
  background: var(--bg);
  color: var(--text);
  line-height: 1.65;
  min-height: 100vh;
  overflow-x: hidden;
}

body::before {
  content: '';
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(57, 211, 83, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(57, 211, 83, 0.03) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.scanline {
  position: fixed;
  inset: 0;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 2px,
    rgba(0, 0, 0, 0.03) 2px,
    rgba(0, 0, 0, 0.03) 4px
  );
  pointer-events: none;
  z-index: 9999;
}

a { color: var(--accent); text-decoration: none; transition: color var(--transition); }
a:hover { color: var(--cyan); }

.container {
  width: min(100% - 2rem, var(--max-width));
  margin: 0 auto;
}

.page { position: relative; z-index: 1; padding-top: var(--nav-height); }

.section-label {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  color: var(--accent);
  letter-spacing: 0.08em;
  margin-bottom: 0.5rem;
}

.section-title {
  font-family: var(--font-mono);
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--text);
}

.section-title::after {
  content: '_';
  color: var(--accent);
  animation: blink 1s step-end infinite;
}

@keyframes blink { 50% { opacity: 0; } }

section { padding: 4rem 0; }

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-family: var(--font-mono);
  font-size: 0.85rem;
  padding: 0.65rem 1.25rem;
  border-radius: var(--radius);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all var(--transition);
  text-decoration: none;
}

.btn-primary {
  background: var(--accent);
  color: var(--bg);
  border-color: var(--accent);
  font-weight: 600;
}

.btn-primary:hover {
  background: #4ae368;
  color: var(--bg);
  box-shadow: 0 0 24px var(--accent-glow);
}

.btn-ghost {
  background: transparent;
  color: var(--text);
  border-color: var(--border);
}

.btn-ghost:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.highlight { color: var(--accent); }
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAEA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR;;wEAEsE;EACtE,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR;;;;;;GAMC;EACD,oBAAoB;EACpB,aAAa;AACf;;AAEA,IAAI,oBAAoB,EAAE,qBAAqB,EAAE,mCAAmC,EAAE;AACtF,UAAU,kBAAkB,EAAE;;AAE9B;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,QAAQ,kBAAkB,EAAE,UAAU,EAAE,8BAA8B,EAAE;;AAExE;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,mBAAmB,MAAM,UAAU,EAAE,EAAE;;AAEvC,UAAU,eAAe,EAAE;;AAE3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,aAAa,oBAAoB,EAAE","sourcesContent":["@import './variables.css';\r\n\r\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\r\n\r\nhtml {\r\n  scroll-behavior: smooth;\r\n  font-size: 16px;\r\n}\r\n\r\nbody {\r\n  font-family: var(--font-sans);\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  line-height: 1.65;\r\n  min-height: 100vh;\r\n  overflow-x: hidden;\r\n}\r\n\r\nbody::before {\r\n  content: '';\r\n  position: fixed;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(57, 211, 83, 0.03) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(57, 211, 83, 0.03) 1px, transparent 1px);\r\n  background-size: 48px 48px;\r\n  pointer-events: none;\r\n  z-index: 0;\r\n}\r\n\r\n.scanline {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: repeating-linear-gradient(\r\n    0deg,\r\n    transparent,\r\n    transparent 2px,\r\n    rgba(0, 0, 0, 0.03) 2px,\r\n    rgba(0, 0, 0, 0.03) 4px\r\n  );\r\n  pointer-events: none;\r\n  z-index: 9999;\r\n}\r\n\r\na { color: var(--accent); text-decoration: none; transition: color var(--transition); }\r\na:hover { color: var(--cyan); }\r\n\r\n.container {\r\n  width: min(100% - 2rem, var(--max-width));\r\n  margin: 0 auto;\r\n}\r\n\r\n.page { position: relative; z-index: 1; padding-top: var(--nav-height); }\r\n\r\n.section-label {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.75rem;\r\n  color: var(--accent);\r\n  letter-spacing: 0.08em;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.section-title {\r\n  font-family: var(--font-mono);\r\n  font-size: clamp(1.5rem, 4vw, 2rem);\r\n  font-weight: 700;\r\n  margin-bottom: 2rem;\r\n  color: var(--text);\r\n}\r\n\r\n.section-title::after {\r\n  content: '_';\r\n  color: var(--accent);\r\n  animation: blink 1s step-end infinite;\r\n}\r\n\r\n@keyframes blink { 50% { opacity: 0; } }\r\n\r\nsection { padding: 4rem 0; }\r\n\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  font-family: var(--font-mono);\r\n  font-size: 0.85rem;\r\n  padding: 0.65rem 1.25rem;\r\n  border-radius: var(--radius);\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  transition: all var(--transition);\r\n  text-decoration: none;\r\n}\r\n\r\n.btn-primary {\r\n  background: var(--accent);\r\n  color: var(--bg);\r\n  border-color: var(--accent);\r\n  font-weight: 600;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #4ae368;\r\n  color: var(--bg);\r\n  box-shadow: 0 0 24px var(--accent-glow);\r\n}\r\n\r\n.btn-ghost {\r\n  background: transparent;\r\n  color: var(--text);\r\n  border-color: var(--border);\r\n}\r\n\r\n.btn-ghost:hover {\r\n  border-color: var(--accent);\r\n  color: var(--accent);\r\n}\r\n\r\n.highlight { color: var(--accent); }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
